/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tab_Continuous_AuditorInputs */

const en_project_tab_continuous_auditor = /** @type {(inputs: Project_Tab_Continuous_AuditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuous Auditor`)
};

const nl_project_tab_continuous_auditor = /** @type {(inputs: Project_Tab_Continuous_AuditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuous Auditor`)
};

/**
* | output |
* | --- |
* | "Continuous Auditor" |
*
* @param {Project_Tab_Continuous_AuditorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_tab_continuous_auditor = /** @type {((inputs?: Project_Tab_Continuous_AuditorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tab_Continuous_AuditorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_project_tab_continuous_auditor(inputs)
	return en_project_tab_continuous_auditor(inputs)
});